<template>
    <div class="portrait-tag-wrap">
        <div class="class-panel">
            <el-input
                v-model="searchName"
                :placeholder="$i18n.t('zhiji.portrait.searchClassify')"
                class="search-tag"
                suffix-icon="el-icon-search"
                @change="getClassData"
            />
            <div class="all-tag">
                <span @click="allTagClick"
                    >{{ $i18n.t("zhiji.portrait.allClassify") }}<em>({{ tagTotal }})</em></span
                >
                <TagEdit :data="{ type: 'add', tagData: { useType: ['1'] } }" @submit="getClassData">
                    <el-button slot="dialogBtn" class="el-icon-plus" size="mini" />
                </TagEdit>
            </div>
            <TagList v-if="tagTotal" :data="tagData" :select-id="search.classId" @click="tagClick" @change="getClassData" />
            <div v-else class="tag-tip">
                <span>{{ $i18n.t("zhiji.portrait.pleaseCrClassify") }}</span>
                <p>{{ tipTxt }}</p>
            </div>
        </div>
        <div class="params-panel">
            <TopSearchListBar class="top-operate">
                <div slot="left">
                    <ParamEdit :data="{ type: 'add' }" :tag-options="tagData" @submit="getList">
                        <el-button slot="dialogBtn" round size="" type="primary">
                            {{ $i18n.t("zhiji.portrait.addTag") }}
                        </el-button>
                    </ParamEdit>
                </div>
                <div slot="right" class="top-right">
                    <el-input
                        v-model="search.word"
                        class="search-input"
                        :placeholder="$i18n.t('zhiji.portrait.writeKwHold')"
                        suffix-icon="el-icon-search"
                        @change="searchChange"
                    >
                        <el-select slot="prepend" v-model="search.type" class="search-select" :placeholder="$i18n.t('zhiji.portrait.selectHold')">
                            <el-option :label="$i18n.t('zhiji.portrait.byTagName')" value="name" />
                        </el-select>
                    </el-input>
                </div>
            </TopSearchListBar>
            <h5 class="notice">{{ tipTxt }}</h5>
            <el-table ref="multipleTable" :data="listInfo.list" width="100%" @selection-change="handleSelectionChange">
                <el-table-column class-name="check-column" type="selection" />
                <el-table-column prop="id" :label="$i18n.t('zhiji.portrait.tagId')" width="120" />
                <el-table-column :label="$i18n.t('zhiji.portrait.tagName')">
                    <template slot-scope="scope">
                        <ParamEdit :data="{ type: 'edit', id: scope.row.id }" :tag-options="tagData" @submit="getList">
                            <el-link slot="dialogBtn" class="edit-link">{{ scope.row.name }}</el-link>
                        </ParamEdit>
                    </template>
                </el-table-column>
                <el-table-column prop="paramNames" :label="$i18n.t('zhiji.portrait.paramName')" />
                <el-table-column prop="paramCondition" :label="$i18n.t('zhiji.portrait.paramCondition')" />
                <el-table-column prop="classifyName" :label="$i18n.t('zhiji.portrait.tagType')" />
                <el-table-column :label="$i18n.t('zhiji.common.operate')">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="deleteClick(scope.row)">
                            {{ $i18n.t("zhiji.common.delete") }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页，修改pageSize-->
            <FooterPage :size="listInfo.size" :total="listInfo.total" :page="listInfo.page" @sizeChange="sizeChange" @pageChange="pageChange">
                <div slot="left" class="bottom-panel">
                    <el-checkbox v-model="isCheckAll" @change="checkAll">{{ $i18n.t("zhiji.common.selectAll") }}</el-checkbox>
                    <el-button icon="el-icon-delete" size="small" @click="deleteCheck"> {{ $i18n.t("zhiji.common.delete") }}</el-button>
                </div>
            </FooterPage>
        </div>
    </div>
</template>

<script>
import TopSearchListBar from "../../TopSearchListBar";
import FooterPage from "../../FooterPage";
import TagList from "./TagList.vue";
import TagEdit from "./TagEdit.vue";
import ParamEdit from "./ParamEdit.vue";
import { getClassList, getTagParams, deleteTagParam } from "../../service";

export default {
    components: {
        TagList,
        TagEdit,
        ParamEdit,
        TopSearchListBar,
        FooterPage
    },
    data() {
        return {
            searchName: "",
            tagData: [],
            tagTotal: 0,
            search: {
                classId: "",
                type: "name",
                word: ""
            },
            listInfo: {
                list: [],
                total: 0,
                page: 1,
                size: 10,
                status: "start" // 'start' //初始状态 'loading' 加载中,'loadingend' 加载完成
            },
            isCheckAll: false,
            checkArr: [] // 选中的数据
        };
    },
    computed: {
        tipTxt() {
            return this.$i18n.t("zhiji.portrait.note");
        }
    },
    mounted() {
        this.getClassData();
        this.getList();
    },
    methods: {
        getClassData() {
            getClassList({
                name: this.searchName
            }).then(result => {
                this.tagData = result.list;
                this.tagTotal = result.count;
            });
        },
        async getList() {
            const { page, size, status } = this.listInfo;

            if (status === "loading") {
                return;
            }

            const { list, count } = await getTagParams({
                ...this.search,
                page,
                size
            });

            this.listInfo.list = list;
            this.listInfo.total = count;
            this.listInfo.status = "loadingend";
            this.checkArr = [];
            this.isCheckAll = false;
        },
        allTagClick() {
            // 所有分类
            this.search.classId = "";
            this.getList();
        },
        tagClick(data) {
            this.search.classId = `${data.id}`;
            this.getList();
        },
        searchChange() {
            this.listInfo.page = 1;
            this.getList();
        },
        sizeChange(data) {
            this.listInfo.page = 1;
            this.listInfo.size = data;
            this.getList();
        },
        pageChange(data) {
            this.listInfo.page = data;
            this.getList();
        },
        deleteClick(data) {
            this.$confirm(this.$i18n.t("zhiji.portrait.delParamTip"), this.$i18n.t("zhiji.common.tips"), {
                confirmButtonText: this.$i18n.t("zhiji.common.confirm"),
                cancelButtonText: this.$i18n.t("zhiji.common.cancel"),
                type: "warning"
            })
                .then(() => {
                    deleteTagParam({
                        id: data.id
                    }).then(() => {
                        this.getList();
                    });
                })
                .catch();
        },
        checkAll(data) {
            if (data) {
                this.$refs.multipleTable.clearSelection();
                this.listInfo.list.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.isCheckAll = this.listInfo.list.length === val.length;
            this.checkArr = val;
        },
        deleteCheck() {
            if (!this.checkArr.length) {
                this.$confirm(this.$i18n.t("zhiji.portrait.pleaseSeleOptData"), this.$i18n.t("zhiji.common.tips"), {
                    type: "warning"
                });
                return;
            }
            this.$confirm(this.$i18n.t("zhiji.portrait.delData"), this.$i18n.t("zhiji.common.tips"), {
                confirmButtonText: this.$i18n.t("zhiji.common.confirm"),
                cancelButtonText: this.$i18n.t("zhiji.common.cancel"),
                type: "warning"
            }).then(() => {
                const checkIds = this.checkArr.map(item => item.id);
                deleteTagParam({
                    id: checkIds.join(",")
                }).then(() => {
                    this.getList();
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.portrait-tag-wrap {
    display: flex;
    height: 100%;
    .class-panel {
        position: relative;
        width: 272px;
        box-sizing: border-box;
        border-right: 1px solid #e3ecf5;
        background: #f2f7fb;
        overflow-x: hidden;
        overflow-y: auto;
        .el-input {
            margin: 16px 16px 8px 16px;
            width: auto;
            display: flex;
        }
        .all-tag {
            position: relative;
            display: flex;
            align-items: center;
            padding: 12px 16px;
            font-size: 12px;
            justify-content: space-between;
            cursor: pointer;
            &:after {
                content: "";
                position: absolute;
                left: 16px;
                bottom: 0;
                right: 0;
                margin: 0 auto;
                width: calc(100% - 32px);
                height: 1px;
                display: inline-block;
                background: #e3edf6;
            }
            span {
                font-weight: bold;
                flex: 1;
            }
            em {
                color: #9b9ba3;
            }
            .el-button {
                padding: 0 4px;
            }
            &:hover {
                background: rgba(217, 235, 246, 0.7);
            }
        }
        .tag-tip {
            padding: 16px 26px;
            span {
                display: block;
                text-align: center;
                margin-bottom: 12px;
            }
            p {
                color: #ff782b;
            }
        }
    }
    .params-panel {
        flex: 1;
        background: #fff;
        padding: 0 24px 0 24px;
        border-radius: 4px;
        overflow-x: hidden;
        overflow-y: auto;
        .top-operate {
            margin-bottom: 5px;
        }
        .notice {
            color: #ff782b;
            margin-bottom: 15px;
        }
        .top-right {
            display: flex;
        }
        .search-input {
            width: 380px;
            margin-left: 8px;

            /deep/.el-input__inner {
                border: 1px solid #d8e4f0;
            }

            /deep/.el-icon-search {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 8px;
                cursor: pointer;
            }
        }
        .search-select {
            width: 130px;
            /deep/.el-input {
                border: 1px solid transparent;
            }
            /deep/.is-focus {
                border-color: #2088f3;
                transition: none;
                box-sizing: border-box;
                border-radius: 4px;
            }
            /deep/.el-input__inner {
                color: #606266;
                border: none;
                height: 30px;
                line-height: 30px;
            }
        }
        .bottom-panel {
            .el-checkbox {
                margin-right: 15px;
            }
        }
        .edit-link {
            font-size: 12px;
        }
    }
    /deep/.el-table {
        .check-column {
            padding-left: 10px;
        }
    }

    .search-tag {
        /deep/.el-input__inner {
            border: 1px solid #d8e4f0;
        }

        /deep/.el-icon-search {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 8px;
            cursor: pointer;
        }
    }
}
</style>
